import type {IContentSubscription} from "@chaosinsight/postoffice-portalclient"
import type {IItemNamed} from "@/managers/data/base/iItem"

export default class ContentSubscription implements IItemNamed {
	public id!: number
	public name!: string
	public logoUrl!: string
	public allowPreApproved!: boolean

	private constructor() {
	}

	private setFromApi(data: IContentSubscription): this {
		this.id = data.Organization.Id
		this.name = data.Organization.Name
		this.logoUrl = data.Organization.LogoUrl
		this.allowPreApproved = data.Subscription.Settings.AllowPreApprovedContent

		return this
	}

	public static fromApi(data: IContentSubscription): ContentSubscription {
		return new ContentSubscription().setFromApi(data)
	}
}
